module.exports = __webpack_public_path__ + "img/a4.9f9a008a.png";